import { render, staticRenderFns } from "./example2.vue?vue&type=template&id=317c12b8&scoped=true&"
import script from "./example2.vue?vue&type=script&lang=js&"
export * from "./example2.vue?vue&type=script&lang=js&"
import style0 from "./example2.vue?vue&type=style&index=0&id=317c12b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317c12b8",
  null
  
)

component.options.__file = "example2.vue"
export default component.exports